import { Route } from "react-router";
import LegacyRedirect from "@routes/LegacyRedirect";
import { LEGACY_SETTINGS_REDIRECTS } from "@routes/legacySettingsRedirects";
import {
  ACCOUNT_INTEGRATIONS,
  ACCOUNT_PREFERENCES,
  ACCOUNT_SCHEDULE,
  ACCOUNT_SECURITY,
  ACCOUNT_SETTINGS,
  CLINIC_SETTINGS,
  CLINIC_SETTINGS_API_KEYS,
  CLINIC_SETTINGS_BILLING,
  CLINIC_SETTINGS_COOPERATION,
  CLINIC_SETTINGS_OFFICES,
  CLINIC_SETTINGS_PAYMENTS,
  CLINIC_SETTINGS_PLAN,
  CLINIC_SETTINGS_PLAN_INVOICES,
  CLINIC_SETTINGS_TEAM,
  GOOGLE_CALLBACK,
} from "@routes/routes";
import {
  AccountIntegrationsPage,
  AccountPreferencesPage,
  AccountProfilePage,
  AccountSchedulePage,
  AccountSecurityPage,
  AccountSettingsPage,
  CallbackPage,
  ClinicBillingPage,
  ClinicGeneralPage,
  ClinicPaymentsPage,
  ClinicPlanPage,
  ClinicSettingsPage,
  CooperationSettingsPage,
  DietitianInvoicesPage,
  EmployeesPage,
  KeysPage,
  OfficesPage,
} from "@routes/lazyPages";

export const settingsRoutes = (
  <>
    <Route path={ACCOUNT_SETTINGS} lazy={AccountSettingsPage}>
      <Route index lazy={AccountProfilePage} />
      <Route path={ACCOUNT_SCHEDULE} lazy={AccountSchedulePage} />
      <Route path={ACCOUNT_INTEGRATIONS} lazy={AccountIntegrationsPage} />
      <Route path={ACCOUNT_SECURITY} lazy={AccountSecurityPage} />
      <Route path={ACCOUNT_PREFERENCES} lazy={AccountPreferencesPage} />
    </Route>

    <Route path={CLINIC_SETTINGS} lazy={ClinicSettingsPage}>
      <Route index lazy={ClinicGeneralPage} />
      <Route path={CLINIC_SETTINGS_OFFICES} lazy={OfficesPage} />
      <Route path={CLINIC_SETTINGS_TEAM} lazy={EmployeesPage} />
      <Route path={CLINIC_SETTINGS_PAYMENTS} lazy={ClinicPaymentsPage} />
      <Route path={CLINIC_SETTINGS_BILLING} lazy={ClinicBillingPage} />
      <Route
        path={CLINIC_SETTINGS_COOPERATION}
        lazy={CooperationSettingsPage}
      />
      <Route path={CLINIC_SETTINGS_PLAN} lazy={ClinicPlanPage} />
      <Route path={CLINIC_SETTINGS_API_KEYS} lazy={KeysPage} />
    </Route>
    <Route path={CLINIC_SETTINGS_PLAN_INVOICES} lazy={DietitianInvoicesPage} />

    {LEGACY_SETTINGS_REDIRECTS.map(({ from, to }) => (
      <Route key={from} path={from} element={<LegacyRedirect to={to} />} />
    ))}

    <Route path={GOOGLE_CALLBACK} lazy={CallbackPage} />
  </>
);
